<template>
  <div>
    <h3 v-if="subscriptionData">Dein Abo <em>{{ subscriptionData.productName }}</em></h3>

    <fin-cancelling-warning
      v-if="isAboCancelled"
      :subscription-cancelled-infos="subscriptionData"
      @unsubscriptionCancelledInfos="val => updateUnscriptionCancelledInfos(val)"/>

    <p v-if="subscriptionData">
      <span style="font-weight: bold">Aktuelles finCraft Abo: </span>
      <br v-if="$vuetify.breakpoint.xsOnly"/>
      <em>{{ subscriptionData.productName }}</em><br/>
    </p>

    <p v-if="subscriptionData">
      <span style="font-weight: bold">Zahlung: </span>
      <br v-if="$vuetify.breakpoint.xsOnly"/>
      <span> {{ getAboType }} </span> seit {{ subscriptionData.periodStart | numericDate }}
      <span v-if="subscriptionData.interval === 'month'">({{ priceModel.price | currency }})</span>
      <span v-else-if="subscriptionData.interval === 'year'">({{ priceModel.price1Y | currency }})</span>
    </p>
    <p
      v-if="subscriptionData && isAboCancelled">
      <span style="font-weight: bold">Ende deines Abos: </span>
      <br v-if="$vuetify.breakpoint.xsOnly"/>
      {{ subscriptionData.periodEnd | numericDate }}
    </p>
    <p v-else-if="subscriptionData">
      <span style="font-weight: bold">Nächster Zahlungstermin: </span>
      <br v-if="$vuetify.breakpoint.xsOnly"/>
      {{ subscriptionData.periodEnd | numericDate }}
    </p>

    <p v-if="subscriptionData && !isAboCancelled">
      Dein finCraft Abo wird am
      <span>{{ subscriptionData.periodEnd | numericDate }}</span> automatisch um 1
      <span>{{ getTransactionInterval }}</span> verlängert.
    </p>

    <p v-if="subscriptionData && !isAboCancelled">
      Du kannst dein Abo jederzeit ändern oder kündigen.
    </p>

    <fin-user-payments class="mt-12"/>

    <div class="mt-6 py-1 d-flex justify-space-between flex-column flex-sm-row">
      <v-btn
        v-if="subscriptionData && isAboCancelled"
        outlined class="mr-sm-2"
        @click="cancelUnsubscription">
        Kündigung rückgängig machen
      </v-btn>
      <v-btn v-else-if="subscriptionData" outlined class="mr-sm-2"
             @click="cancelCurrentAbo">
        Abo&nbsp;<em>{{ subscriptionData.productName }}</em>&nbsp;kündigen
      </v-btn>
      <v-btn dark @click="abortShowDetails">Zurück zum Überblick</v-btn>
    </div>
  </div>
</template>

<script>
import FinUserPayments from "@/components/pages/profile/payments/Payments"
import {API, graphqlOperation} from "@/plugins/finAmplifyModules"
import {
  cancelSubscription,
  cancelUnsubscription
} from "@/components/pages/profile/subscription/graphql"
import FinCancellingWarning from "@/components/pages/profile/subscription/cancellingWarning"
import {mapGetters} from "vuex"


export default {
  name: "FinCurrentSubscriptionDetails",
  components: {FinCancellingWarning, FinUserPayments},
  props: {
    subscriptionData: {
      type: Object
    },
    priceModel: {
      type: Object,
    }
  },
  data() {
    return {}
  },
  methods: {
    abortShowDetails() {
      this.$emit('cancelShowDetails')
    },
    async cancelCurrentAbo() {
      await API.graphql(graphqlOperation(cancelSubscription)).then(res => {
        console.log("cancelCurrentAbo res", res)
        this.$store.commit('auth/subscriptionChanged', res.data.cancelSubscription.subscriptionId)
        this.$emit("updateSubscription", res.data.cancelSubscription)
      }).catch(e => {
        console.error("Failed to cancel subscription", e)
      })

    },
    async cancelUnsubscription() {
      await API.graphql(graphqlOperation(cancelUnsubscription)).then(res => {
        console.log("cancelUnsubscription res", res)
        this.$store.commit('auth/subscriptionChanged', res.data.cancelUnsubscription.metadata.groupId)
        this.$emit("updateSubscription", res.data.cancelUnsubscription)
      }).catch(e => {
        console.error("Failed to cancel unsubscription", e)
      })
    },
    updateUnscriptionCancelledInfos(val) {
      this.$emit("updateSubscription", val)
    }
  },
  computed: {
    ...mapGetters('auth', ['groupPriceModel', 'profile']),
    isAboCancelled() {
      console.log("isAboCancelled this.subscriptionData", this.subscriptionData)
      console.log("isAboCancelled this.groupPriceModel", this.groupPriceModel)
      console.log("isAboCancelled this.profile", this.profile)
      return (this.subscriptionData && this.subscriptionData.cancelAtPeriodEnd) ||
        (this.groupPriceModel.id !== 'BASIC' && this.groupPriceModel.id !== 'TRIAL' &&
          this.profile.subscriptionChange === 'BASIC')
    },
    getTransactionInterval() {
      if (this.subscriptionData?.interval === "month") {
        return "Monat"
      } else if (this.subscriptionData?.interval === "year") {
        return "Jahr"
      } else {
        return undefined
      }
    },
    getAboType() {
      if (this.subscriptionData?.interval === "month") {
        return "Monatlich"
      } else if (this.subscriptionData?.interval === "year") {
        return "Jährlich"
      } else {
        return undefined
      }
    },
  }
}
</script>

<style lang="scss" scoped>

</style>
